import React from 'react'
import Navbar from './component/Navbar.js';
import HeaderBlog from './component/header/header3.js';
import Footer from './component/Footer.js';

function Blog() {
    return (
        <>
            <Navbar />
            <HeaderBlog />
            <Footer />
        </>
    )
}

export default Blog;